import Application from "../../Application";
import { IAuthenticationService } from "../service/AuthenticationService";
import { ICredentialsService } from "../service/CredentialsService";
import { IRouter } from "../../runtime/Router";
import { ILanguageService } from "../../core/service/language/LanguageService";
import { Errors } from "../../core/common/Constants";
export default class LoginInteractor {
  private application: Application;
  private authenticationService: IAuthenticationService;
  private credentialsService: ICredentialsService;
  private languageService: ILanguageService;
  private router: IRouter;

  constructor({
    application,
    authenticationService,
    credentialsService,
    languageService,
    router
  }: any) {
    this.application = application;
    this.authenticationService = authenticationService;
    this.credentialsService = credentialsService;
    this.languageService = languageService;
    this.router = router;
  }

  async execute(username: string, password: string, redirectRoute?: string) {
    try {
      const { languageCode } = await this.authenticationService.login(
        username,
        password
      );
      const userSelectedLanguageCode =
        await this.credentialsService.getLanguage();
      if (userSelectedLanguageCode) {
        await this.languageService.changeLanguage(userSelectedLanguageCode);
      } else {
        await this.credentialsService.setLanguage(languageCode);
      }

      this.credentialsService.setIsLoggedIn(true);

      if (redirectRoute) {
        const splittedRoute = redirectRoute.split("?");
        this.router.replace({
          pathname: splittedRoute[0],
          search: splittedRoute[1]
        });
      } else {
        this.router.replace({
          pathname: "/"
        });
      }
    } catch (error: any) {
      if (
        error.message.substring(0, 1) === Errors.EXPIRED_PASSWORD.toString()
      ) {
        return this.router.replace({
          pathname: "/set-password",
          state: {
            username,
            oldPassword: password
          }
        });
      }
      console.log(error);
      return error;
    }
  }
}
